import { render, staticRenderFns } from "./configuracionPerfil.vue?vue&type=template&id=d9ef5af8&scoped=true"
import script from "./configuracionPerfil.vue?vue&type=script&lang=js"
export * from "./configuracionPerfil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9ef5af8",
  null
  
)

export default component.exports